/**
 * Password validation
 * @param string password
 */
export function isValidPassword(password) {
  const expression = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(?=.{8,})/;
  return expression.test(password);
}
